import { useState, useEffect } from "react";
import { get, post, del } from "../services/api";
import { toast } from "react-toastify";

function useFileManager() {
  const [currentPath, setCurrentPath] = useState("\\");
  const [currentFolderName, setCurrentFolderName] = useState("");
  const [folders, setFolders] = useState([]);
  const [files, setFiles] = useState([]);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const roleId = localStorage.getItem("roleId");
  const organizationId = localStorage.getItem("organizationId");

  const goToFolder = async (folderName, source) => {
    if (loading) return;

    var newPath =
      currentPath === "\\"
        ? `\\${folderName}`
        : `${currentPath}\\${folderName}`;
    if (source == "Sidebar") newPath = folderName;
    else newPath = `${currentPath}\\${folderName}`;

    if (newPath === "\\") {
      setCurrentPath("\\");
      setCurrentFolderName("");
      await loadFolders();
      return;
    }

    setLoading(true);
    setCurrentPath(newPath);
    setCurrentFolderName(folderName);
    const folderPath = currentPath === "\\" ? "\\" : currentPath;
    console.log(newPath);
    try {
      const response = await post(
        `FileManager/Exp_FilesAndFolders?folderPath=${encodeURIComponent(
          `\\${organizationId}${newPath}`
        )}`,
        null, // No body, since this is a GET-like operation
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setFiles(response.folderAndFiles);
      setClearSelectedRows((prev) => !prev);
    } catch (error) {
      console.error("Failed to load files or folders:", error);
      toast.error("Failed to load files or folders");
    } finally {
      setLoading(false);
    }
  };

  const goBack = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const updatedPath = currentPath.split("\\").filter(Boolean);
      updatedPath.pop();
      const newPath = updatedPath.length ? `\\${updatedPath.join("\\")}` : "\\";
      setCurrentPath(newPath);
      await exploreFolders(newPath, "");
    } catch (error) {
      console.error("Error while navigating back:", error);
    } finally {
      setLoading(false);
    }
  };

  const goHome = async () => {
    if (loading) return;
    setLoading(true);
    try {
      loadFolders();
      // await exploreFolders("\\", "");
      // setCurrentPath("\\");
      // setCurrentFolderName("");
      // setClearSelectedRows((prev) => !prev);
    } catch (error) {
      console.error("Error while navigating home:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFolders();
  }, []);

  const loadFolders = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const response = await get(
        `FileManager/GetFilesAndFolders?roleId=${roleId}&organizationId=${organizationId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setFolders(response.folderAndFiles);
      setFiles([]);
    } catch (error) {
      console.error("Failed to load folders:", error);
      toast.error("Failed to load folders");
    } finally {
      setLoading(false);
    }
  };

  const exploreFolders = async (path, folderName) => {
    if (path === "\\") {
      await loadFolders();
      return;
    }
    if (loading) return;
    setLoading(true);
    try {
      const response = await post(
        `FileManager/Exp_FilesAndFolders?folderPath=${encodeURIComponent(
          `\\${organizationId}${path}`
        )}`,
        null, // No body, since this is a GET-like operation
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setFiles(response.folderAndFiles);
      //setFolders(response.folderAndFiles);
      setClearSelectedRows((prev) => !prev);
    } catch (error) {
      console.error("Failed to load files:", error);
      toast.error("Failed to load files");
    } finally {
      setLoading(false);
    }
  };

  const refreshExplorer = async (currentPath) => {
    const segments = currentPath.split("\\").filter(Boolean);
    segments.pop();
    return segments.length ? `\\${segments.join("\\")}` : "\\";
  };

  const createFile = async (fileName) => {
    if (loading) return;
    setLoading(true);
    try {
      const response = await post(
        `FileManager/CreateFolders?path=${encodeURIComponent(
          `\\${organizationId}${currentPath}`
        )}&folderName=${encodeURIComponent(
          fileName
        )}&organizationId=${organizationId}`,
        null, // Assuming the body is not needed for this request
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setCurrentPath(currentPath);
      const newCurrentPath = await refreshExplorer(currentPath);

      if (response.isSuccess && response.status) {
        toast.success("Success!");
        await exploreFolders(currentPath, "");
      } else {
        toast.error("Failed to create folder");
      }
    } catch (error) {
      console.error("Failed to create folder:", error);
      toast.error("Failed to create folder");
    } finally {
      setLoading(false);
    }
  };

  const renameFile = async (selectedFileName, newName, isFolder) => {
    if (loading) return;
    setLoading(true);
    try {
      const response = await post(
        `FileManager/RenameItem?folderPath=${encodeURIComponent(
          `\\${organizationId}${currentPath}`
        )}&newname=${encodeURIComponent(newName)}&oldname=${encodeURIComponent(
          selectedFileName
        )}&isFolder=${isFolder}`,
        null, // No request body, since data is sent as URL parameters
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token if required for authorization
          },
        }
      );
      if (response.isSuccess && response.success) {
        toast.success("Success!");
        await exploreFolders(currentPath, "");
      } else {
        toast.error("Failed to rename");
      }
    } catch (error) {
      console.error("Failed to rename:", error);
      toast.error("Failed to rename");
    } finally {
      setLoading(false);
    }
  };

  const deleteFile = async (ItemNames) => {
    if (loading) return;
    setLoading(true);
    try {
      const response = await post(
        "FileManager/DeleteFilesAndFolders",
        {
          ItemNames: ItemNames, // Replace with your array of item names to delete
          Path: `\\${organizationId}${currentPath}`, // Pass the current folder path
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const newCurrentPath = await refreshExplorer(currentPath);

      if (response.isSuccess) {
        toast.success("Success!");
        await exploreFolders(currentPath, currentFolderName);
      } else {
        toast.error("Failed to delete.");
      }
    } catch (error) {
      console.error("Failed to delete file:", error);
      toast.error("Failed to delete file");
    } finally {
      setLoading(false);
    }
  };

  const downloadFile = async (fileNames) => {
    if (loading) return;
    setLoading(true);

    const apiUrl = `${process.env.REACT_APP_API_URL}FileManager/DownloadFiles`;

    // const response = await post(
    //   `FileManager/DownloadFiles?path=${encodeURIComponent(
    //     currentPath
    //   )}&fileName=${encodeURIComponent(fileNames)}`,
    //   null, // No body, since this is a GET-like operation
    //   {
    //     headers: { Authorization: `Bearer ${token}` },
    //     responseType: "blob", // This tells the request to expect a binary response (like a file)
    //   }
    // );

    try {
      // Prepare the request headers and body for the POST request
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`); // Add Bearer token for authorization

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          ItemNames: fileNames,
          Path: `\\${organizationId}${currentPath}`,
        }), // Pass fileNames array as JSON body
        redirect: "follow",
      };

      // Fetch response as a blob
      const response = await fetch(apiUrl, requestOptions);

      // Check if the response is ok (status 200)
      if (!response.ok) {
        throw new Error("Failed to download file.");
      }

      // Get the response as a blob
      const blob = await response.blob();

      // Extract filename from the Content-Disposition header if available
      const contentDisposition = response.headers.get("content-disposition");
      const filenameMatch =
        contentDisposition &&
        contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      const filename = filenameMatch
        ? filenameMatch[1].replace(/['"]/g, "")
        : "downloaded_items.zip";

      // Create a URL for the blob and simulate a download
      const fileURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", filename); // Set filename from header or use default
      document.body.appendChild(link);
      link.click();

      // Clean up by revoking object URL and removing link element
      document.body.removeChild(link);
      window.URL.revokeObjectURL(fileURL);
    } catch (error) {
      console.error("Failed to download file:", error);
      toast.error("Failed to download file");
    } finally {
      setLoading(false);
    }
  };

  const uploadFile = async (files) => {
    if (loading) return;
    setLoading(true);
    try {
      const formData = new FormData();

      Array.from(files).forEach((file) => {
        formData.append("files", file);
      });

      const response = await post(
        `FileManager/UploadFiles?path=${encodeURIComponent(
          `\\${organizationId}${currentPath}`
        )}`,
        formData, // FormData object containing file data
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Include token if needed
          },
        }
      );

      if (response.isSuccess) {
        toast.success("Success!");
        await exploreFolders(currentPath, "");
      } else {
        toast.error("Failed to upload.");
      }
    } catch (error) {
      console.error("Failed to upload files:", error);
      toast.error("Failed to upload files");
    } finally {
      setLoading(false);
    }
  };

  const uploadLinkFile = async (ItemNames) => {
    if (loading) return;
    setLoading(true);
    try {
      const response = await post(
        `FileManager/UploadLinkFile?path=${encodeURIComponent(
          `\\${organizationId}${currentPath}`
        )}&ItemNames=${encodeURIComponent(ItemNames)}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const newCurrentPath = await refreshExplorer(currentPath);

      if (response.isSuccess) {
        toast.success("Success!");
        await exploreFolders(newCurrentPath, currentFolderName);
      } else {
        toast.error("Failed to delete.");
      }
    } catch (error) {
      console.error("Failed to delete file:", error);
      toast.error("Failed to delete file");
    } finally {
      setLoading(false);
    }
  };

  const copyFile = async (sourcePath, destinationPath, itemNames) => {
    if (loading) return;
    setLoading(true);
    try {
      const payload = {
        sourcePath: `\\${organizationId}${sourcePath || "\\"}`,
        destinationPath: `\\${organizationId}${destinationPath || "\\"}`,
        itemName: itemNames,
      };

      const response = await post(`FileManager/CopyItems`, payload, {
        headers: {
          Authorization: `Bearer ${token}`, // Add the Bearer token here
          "Content-Type": "application/json", // Optional: Set the content type to JSON if needed
        },
      });
      const newCurrentPath = await refreshExplorer(destinationPath);

      if (response.isSuccess) {
        toast.success("Success!");
        await exploreFolders(destinationPath, "");
      } else {
        toast.error("Failed to copy files");
      }
    } catch (error) {
      console.error("Failed to copy files:", error);
      toast.error("Failed to copy files");
    } finally {
      setLoading(false);
    }
  };

  const moveFile = async (sourcePath, destinationPath, itemNames) => {
    if (loading) return;
    setLoading(true);

    try {
      const payload = {
        sourcePath: `\\${organizationId}${sourcePath || "\\"}`,
        destinationPath: `\\${organizationId}${destinationPath || "\\"}`,
        itemName: itemNames,
      };
      const response = await post(`FileManager/MoveItems`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.isSuccess) {
        toast.success("Success!");
        await exploreFolders(destinationPath, "");
      } else {
        toast.error("Failed to move files");
      }
    } catch (error) {
      console.error("Failed to move files:", error);
      toast.error("Failed to move files");
    } finally {
      setLoading(false);
    }
  };

  const previewFile = async (selectedFile) => {
    if (loading) return;
    setLoading(true);
    const previewableTypes = ["image", "video", "pdf"];

    if (selectedFile.type === "Folder") {
      await exploreFolders(currentPath, selectedFile.name);
    } else if (
      previewableTypes.some((type) => selectedFile.type.includes(type))
    ) {
      try {
        const response = await get(
          `FileManager/ViewFiles?folderPath=${encodeURIComponent(
            `\\${organizationId}${currentPath}`
          )}&fileName=${encodeURIComponent(selectedFile.name)}`,
          {
            responseType: "blob", // Ensures that the response is a blob (binary data)
            headers: {
              Authorization: `Bearer ${token}`, // Add token if necessary
            },
          }
        );

        const blob = new Blob([response], { type: selectedFile.type });
        const blobUrl = URL.createObjectURL(blob);

        window.open(blobUrl, "_blank");

        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000 * 60 * 5); // 5 minutes delay
      } catch (error) {
        console.error("Failed to preview file:", error);
      } finally {
        setLoading(false);
      }
    } else {
      downloadFile([selectedFile.name]);
    }
  };

  return {
    folders,
    files,
    currentPath,
    createFile,
    renameFile,
    deleteFile,
    downloadFile,
    uploadFile,
    uploadLinkFile,
    copyFile,
    moveFile,
    previewFile,
    setCurrentFolderName,
    goBack,
    goHome,
    goToFolder,
    clearSelectedRows,
    setClearSelectedRows,
    loading,
  };
}

export default useFileManager;
